import connect from "@classdojo/web/utils/hoc/connect";
import DirectionsDisplay from "./DirectionsDisplay";
import { appMetadataList, ListSlice } from "src/pods/list";
import { displayClose } from "src/pods/realtime";
import { ToolListItem } from "src/pods/toolkitData/components/EditableSetup";
import PresentationPage from "src/shared/components/PresentationPage";

const mapStateToProps = (state: ListSlice) => {
  return { ...state.list, fullscreen: true };
};
const mapDispatchToProps = { displayClose };

type DirectionsDisplayContainerProps = {
  displayClose: VoidFunction;
  fullscreen: boolean;
  list: ToolListItem[];
  title: string;
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)((props: Partial<DirectionsDisplayContainerProps>) => (
  <PresentationPage {...appMetadataList()} onRequestHide={props.displayClose}>
    <DirectionsDisplay {...props} />
  </PresentationPage>
));
